import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { StepTitle } from '../views-components/StepTitle';
import { Step } from '../views/Step';
export const ExistingUserTitle = ({
  user,
  shouldShowSubtitle = true
}) => {
  const locale = getApplicationLocale();
  const isJapanese = locale === Locale.ja;
  const stepKey = Step.ExistingUser;
  const name = isJapanese ? user.lastName : user.firstName;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StepTitle, {
      shouldShowDefault: false,
      stepKey: stepKey,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: name ? `views.${stepKey}.title.default` : `views.${stepKey}.titleWithoutName`,
        options: {
          name
        }
      })
    }), shouldShowSubtitle && /*#__PURE__*/_jsx("div", {
      className: "text-center",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `views.${stepKey}.subtitle`
      })
    })]
  });
};